import React from 'react';
import { usePlanningActualState } from '../Context/index';

function SalesPerOptionTableTotal({ years }) {
  const { checkVisible, getOvarAllFieldTotal } = usePlanningActualState();
  const salesPerOptions = [
    {
      keyName: 'plannedSPO',
      name: 'Planned Sales Per Option',
    },
    {
      keyName: 'actualSPO',
      name: 'Actual Sales Per Option',
    },
  ];
  return (years ?? [])?.map((currentYear, yearIndex) => {
    return (
      <table key={yearIndex} className="table custom-table layout-fixed  font-13 mr-3">
        <thead>
          <tr>
            {salesPerOptions.map((salesItem, i) => {
              const isVisible = checkVisible(salesItem.keyName);
              return (
                isVisible && (
                  <th key={i} className="w-200px">
                    <span>
                      {currentYear}&nbsp;
                      {salesItem.name}
                    </span>
                  </th>
                )
              );
            })}
          </tr>
        </thead>
        <tbody>
          <tr>
            {salesPerOptions.map((salesItem, i) => {
              const isVisible = checkVisible(salesItem.keyName);
              return isVisible && <td key={i}>{getOvarAllFieldTotal(salesItem.keyName, yearIndex, currentYear)}</td>;
            })}
          </tr>
        </tbody>
      </table>
    );
  });
}
export default SalesPerOptionTableTotal;
